let moreNewsButton = $('.js-load-more-news');
// if (moreNewsButton.hasClass('js-external-news')) {
//     moreNewsButton = $('#js-load-more-external-news');
// }

// console.log(moreNewsButton);

if (moreNewsButton.length) {

    moreNewsButton.on('click', function () {
        loadMoreNews(this);
        return false;
    })

    function loadMoreNews(elm) {

        let moreNewsButton = $(elm);

        let isExternal = moreNewsButton.hasClass('js-external-news');


        // console.log(window.news_params.query_vars);

        let data = {
            'action': 'load_more_news',
            'page': window.news_params.current_page,
            'posts_per_page': window.news_params.posts_per_page,
            'featured_posts': window.news_params.featured_posts
        };

        if (isExternal) {
            data = {
                'action': 'load_more_external_news',
                'page': window.external_news_params.current_page,
                'posts_per_page': window.external_news_params.posts_per_page,
                'featured_posts': window.external_news_params.featured_posts
            };
        }


        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            data: data,
            type: 'POST',
            beforeSend: function (xhr) {
                moreNewsButton.text('Loading...'); // change the moreNewsButton text, you can also add a preloader image
            },
            success: function (data) {
                if (data) {
                    moreNewsButton.text('Load More');
                    $(data).insertBefore(moreNewsButton);
                    // moreNewsButton.prepend(data.html);
                    if (isExternal) {
                        window.external_news_params.current_page++;
                        if (parseInt(window.external_news_params.current_page) === parseInt(window.external_news_params.max_page))
                            moreNewsButton.remove();
                    } else {
                        window.news_params.current_page++;
                        if (parseInt(window.news_params.current_page) === parseInt(window.news_params.max_page))
                            moreNewsButton.remove();
                    }




                } else {
                    moreNewsButton.remove();
                }
            }
        });


    }

}